import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../Routes/AuthProvider"
import ModifySearch from "./ModifySearch";
import Header from "../../Components/Header";
import FilterLeft from "./FilterLeft";
import { BusSearchResults } from "../../Services/BusAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { BusSeatLayout, SaveSelectedTrip } from "../../Services/BusAPI";


const Result = () => {
    const { name, userName, roles, corporateId } = useContext(AuthContext);
    const location = useLocation();
    const searchData = location.state;
    const [busData, setBusData] = useState([]);
    const [seatData, setSeatData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [activeTabs, setActiveTabs] = useState({});
    const [traceId, setTraceId] = useState("");
    const [tripKey, setTripKey] = useState("");
    const [key, setKey] = useState("");
    const [clientCode, setClientCode] = useState("");
    const [showFilter, setShowFilter] = useState(false);

    // full response
    const bookingData = location.state;

    // query param
    const queryParams = new URLSearchParams(location.search);
    const referenceNo = queryParams.get("referenceNo");

    //console.log("Reference No:", referenceNo);
    const [seatLoading, setSeatLoading] = useState({});

    const handleTabClick = (busIndex, tabName) => {
        setActiveTabs((prev) => ({
            ...prev,
            [busIndex]: prev[busIndex] === tabName ? null : tabName,
        }));
    };


    useEffect(() => {
        const fetchBuses = async () => {
            try {
                setLoading(true);
                const corporateCode = localStorage.getItem("selectedCorporateCode");
                const userId = localStorage.getItem("selectedUserId");
                const CorpTraveller = userId ?? userName;
                const CorpCode = corporateCode ?? corporateId;
                const is_Emulate = !!corporateCode;

                const requestBody = {
                    travelPurpose: Number(searchData?.travelType),
                    loggedInUserId: userName,
                    corporateTraveller: CorpTraveller,
                    corporateCode: CorpCode,
                    isEmulated: is_Emulate,
                    trips: [
                        {
                            source: searchData?.fromCityId,
                            destination: searchData?.toCityId,
                            journeyDate: searchData?.journeyDate
                        }
                    ],
                    ext: {
                        timeout: 60000,
                        filters: true,
                        tags: [],
                        api: []
                    }
                };
                const res = await BusSearchResults(requestBody);
                //console.log("BusSearchResults", res);
                // setBusData(res?.trips?.[0]?.buses || []);
                setTraceId(res?.traceId || "");
                setTripKey(res?.tripKey || "");
                setKey(res?.key || "");
                setClientCode(res?.clientCode || "");
                const buses = res?.trips?.[0]?.buses || [];

                setBusData(buses);

                //  ALL FILTERS MUST BE CREATED HERE
                setFilters({
                    priceRanges: [
                        "Below ₹1000",
                        "₹1000 - ₹2000",
                        "₹2000 - ₹3000",
                        "Above ₹3000"
                    ],

                    timings: [
                        "Morning (6AM-12PM)",
                        "Afternoon (12PM-6PM)",
                        "Evening (6PM-12AM)",
                        "Night (12AM-6AM)"
                    ],

                    busTypes: [...new Set(buses.map(b => b.type))],
                    travels: [...new Set(buses.map(b => b.name))],

                    boardingPoints: [
                        ...new Set(
                            buses.flatMap(b => b.boarding?.map(p => p.name) || [])
                        ),
                    ],

                    droppingPoints: [
                        ...new Set(
                            buses.flatMap(b => b.dropping?.map(p => p.name) || [])
                        ),
                    ],
                });
            } catch (err) {
                console.error("API Error:", err);
                setBusData([]);
            } finally {
                setLoading(false);
            }
        };

        if (searchData) fetchBuses();
    }, [searchData]);

    const navigate = useNavigate();

    const formatTime = (time) =>
        time
            ? new Date(time).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
            })
            : "--:--";

    const formatDate = (time) =>
        time ? new Date(time).toDateString() : "";





    //  Split decks

    const BusSeatReviewAndBook = async (bus, index) => {
        try {
            if (!bus) return;

            setSeatLoading(prev => ({ ...prev, [index]: true }));
            const corporateCode = localStorage.getItem("selectedCorporateCode");
            const userId = localStorage.getItem("selectedUserId");
            const CorpTraveller = userId ?? userName;
            const CorpCode = corporateCode ?? corporateId;
            const is_Emulate = !!corporateCode;

            const requestBody = {
                travelPurpose: Number(searchData?.travelType),
                loggedInUserId: userName,
                corporateTraveller: CorpTraveller,
                corporateCode: CorpCode,
                isEmulated: is_Emulate,
                key: key,
                clientCode: clientCode,
                BusId: bus?.id,
                TraceId: traceId,
                TripKey: bus?.tripKey,   //  FIXED

                AccessToken: "test",
                BoardingPointId: bus?.boarding?.[0]?.id,
                DroppingPointId: bus?.dropping?.[0]?.id,
                Ext: {
                    Timeout: 0,
                    Layout: 1
                }
            };

            const response = await BusSeatLayout(requestBody);
            //setTripKey(response?.tripKey || "");
            const updatedBus = {
                ...bus,
                tripKey: response?.tripKey || bus?.tripKey
            };

            setSelectedBus(updatedBus);

            setSeatData(prev => ({
                ...prev,
                [index]: response
            }));

        } catch (error) {
            console.error(error);
        } finally {
            setSeatLoading(prev => ({ ...prev, [index]: false }));
        }
    };

    //  Safety check
    const [selectedSeats, setSelectedSeats] = useState([]);
    const [selectedBoarding, setSelectedBoarding] = useState(null);
    const [selectedDropping, setSelectedDropping] = useState(null);

    const MAX_SEATS = 6;

    const handleSeatClick = (seat) => {
        const statusMap = {
            0: "AFA",
            1: "AFM",
            2: "AFF",
            3: "BFA",
            4: "BFM",
            5: "BFF"
        };

        const status = statusMap[seat.status];

        //  Block booked seats
        if (["BFA", "BFM", "BFF"].includes(status)) return;

        const alreadySelected = selectedSeats.some(s => s.name === seat.name);

        //  Unselect if already selected
        if (alreadySelected) {
            setSelectedSeats(prev =>
                prev.filter(s => s.name !== seat.name)
            );
            return;
        }

        //  Max seat limit
        if (selectedSeats.length >= MAX_SEATS) {
            alert(`You can select maximum ${MAX_SEATS} seats`);
            return;
        }

        //  Add seat
        setSelectedSeats(prev => [...prev, seat]);
    };


    const totalFare = selectedSeats.reduce(
        (sum, seat) => sum + (seat.fare?.companyAmount || 0),
        0
    );
    const [selectedBus, setSelectedBus] = useState(null);

    const handleBusBooking = async () => {
        try {
            if (!selectedSeats.length || !selectedBoarding || !selectedDropping) {
                alert("Please select seats, boarding and dropping points");
                return;
            }
            const corporateCode = localStorage.getItem("selectedCorporateCode");
            const userId = localStorage.getItem("selectedUserId");
            const CorpTraveller = userId ?? userName;
            const CorpCode = corporateCode ?? corporateId;
            const is_Emulate = !!corporateCode;

            const requestBody = {
                travelPurpose: Number(searchData?.travelType),
                loggedInUserId: userName,
                corporateTraveller: CorpTraveller,
                corporateCode: CorpCode,
                isEmulated: is_Emulate,
                key: key,
                clientCode: "BerryJourneys",

                trip: {
                    tripIndex: 0,
                    busId: String(selectedBus?.id || ""),
                    traceId: String(traceId || ""),
                    tripKey: String(selectedBus?.tripKey || ""),
                    selectedSeats: selectedSeats.map(s => s.name).join(","),
                    sourceId: String(searchData?.fromCityId || ""),
                    destinationId: String(searchData?.toCityId || ""),
                    sourceName: String(searchData?.fromCity || ""),
                    destinationName: String(searchData?.toCity || ""),
                    journeyDate: new Date(searchData?.journeyDate).toISOString(),
                    operatorName: String(selectedBus?.name || ""),
                    busType: String(selectedBus?.type || ""),
                    departureTime: selectedBus?.timeD,
                    arrivalTime: selectedBus?.timeA,
                    partialCancellationAllowed: true,
                    mTicketAllowed: true,
                    isRTC: false,
                    isAc: true,
                    supplierName: String(selectedBus?.name || ""),
                    netFare: selectedSeats.reduce(
                        (sum, s) => sum + (s.fare?.companyAmount || 0),
                        0
                    ),
                    publishedFare: selectedSeats.reduce(
                        (sum, s) => sum + (s.fare?.companyAmount || 0),
                        0
                    ),
                },

                points: {
                    tripIndex: "0",
                    sourceId: String(searchData?.fromCityId || ""),
                    destinationId: String(searchData?.toCityId || ""),
                    sourceName: String(searchData?.fromCity || ""),
                    destinationName: String(searchData?.toCity || ""),
                    boardingPointId: String(selectedBoarding?.id || ""),
                    boardingPointLocation: String(selectedBoarding?.name || ""),
                    boardingPointTime: selectedBoarding?.time,
                    droppingPointId: String(selectedDropping?.id || ""),
                    droppingPointLocation: String(selectedDropping?.name || ""),
                    droppingPointTime: selectedDropping?.time,
                },

                fareDetail: selectedSeats.reduce((seatFare, seat) => {
                    seatFare.referenceNo = "";
                    seatFare.baseFare += seat.fare?.base || 0;
                    seatFare.tax += 0;
                    seatFare.gst += seat.fare?.gst || 0;
                    seatFare.serviceCharge += seat.fare?.sCharge || 0;
                    //seatFare.operatorServiceCharge += 0;
                    seatFare.tollCharge += seat.fare?.toll || 0;
                    seatFare.levyCharge += seat.fare?.levyCharge || 0;
                    seatFare.discount += 0;
                    seatFare.supplierAmount += seat.fare?.total || 0;
                    seatFare.commissionEarned += seat.fare?.commission || 0;
                    seatFare.companyMarkUp += seat.fare?.companyMarkUp || 0;
                    seatFare.managementFees += seat.fare?.managementFees || 0;
                    seatFare.managementFeesGST += seat.fare?.managementFeesGST || 0;
                    seatFare.companyAmount += seat.fare?.companyAmount || 0;
                    seatFare.corporateAmount += seat.fare?.companyAmount || 0;
                    seatFare.totalFare += seat.fare?.companyAmount || 0;
                    seatFare.policyStatus = ((seatFare.policyStatus === null || seatFare.policyStatus === undefined || seatFare.policyStatus === "WithinPolicy") && seat.fare?.policyStatus === "WithinPolicy") ? "WithinPolicy" : "OutOfPolicy";
                    seatFare.policyReason = (seatFare.policyViolationReason ? seatFare.policyViolationReason + ", " : "") + seat.fare.policyViolationReason;

                    return seatFare;
                }, {
                    referenceNo: "",
                    baseFare: 0,
                    tax: 0,
                    gst: 0,
                    serviceCharge: 0,
                    //operatorServiceCharge: 0,
                    tollCharge: 0,
                    levyCharge: 0,
                    discount: 0,
                    supplierAmount: 0,
                    commissionEarned: 0,
                    companyMarkUp: 0,
                    managementFees: 0,
                    managementFeesGST: 0,
                    companyAmount: 0,
                    corporateAmount: 0,
                    totalFare: 0
                })
            };
            //console.log("FINAL BOOKING BODY:", requestBody);
            //console.log("TRIP KEY SENT:", selectedBus?.tripKey); // ✅ DEBUG

            const res = await SaveSelectedTrip(requestBody);
            if (res) {
                window.scrollTo(0, 0);
                navigate(
                    `/bus/BusBooking?referenceNo=${res?.referenceNo}&key=${res?.key}`,
                    { state: res }
                );
            }

        } catch (err) {
            console.error("BOOKING ERROR:", err);
        }
    };

    const createSeatGrid = (seats) => {
        const grid = [];

        seats.forEach((seat) => {
            const row = seat.y;   // row index
            const col = seat.x;   // column index

            if (!grid[row]) grid[row] = [];
            grid[row][col] = seat;
        });

        return grid;
    };


    // buses filter start

    const handleFilterChange = (type, value, checked) => {
        setSelectedFilters(prev => {
            const updated = { ...prev };

            if (!updated[type]) updated[type] = [];

            if (checked) {
                updated[type].push(value);
            } else {
                updated[type] = updated[type].filter(v => v !== value);
            }

            return updated;
        });
    };




    //const [busData, setBusData] = useState([]);
    const [filters, setFilters] = useState({});
    const [selectedFilters, setSelectedFilters] = useState({
        price: [],
        timings: [],
        busTypes: [],
        travels: [],
        boardingPoints: [],
        droppingPoints: []
    });

    //  Fetch Data


    //  Handle Filter Change
    const onFilterChange = (type, value, checked) => {
        setSelectedFilters(prev => {
            const updated = { ...prev };

            if (checked) {
                updated[type] = [...(updated[type] || []), value];
            } else {
                updated[type] = updated[type].filter(v => v !== value);
            }

            return updated;
        });
    };




    //  Apply Filters
    const getTimeSlot = (time) => {
        const hour = new Date(time).getHours();

        if (hour >= 6 && hour < 12) return "Morning (6AM-12PM)";
        if (hour >= 12 && hour < 18) return "Afternoon (12PM-6PM)";
        if (hour >= 18 && hour < 24) return "Evening (6PM-12AM)";
        return "Night (12AM-6AM)";
    };

    const checkPrice = (bus) => {
        const fare = bus?.fares?.[0]?.companyAmount || 0;

        if (!selectedFilters.price.length) return true;

        return selectedFilters.price.some(range => {
            if (range === "Below ₹1000") return fare < 1000;
            if (range === "₹1000 - ₹2000") return fare >= 1000 && fare <= 2000;
            if (range === "₹2000 - ₹3000") return fare > 2000 && fare <= 3000;
            if (range === "Above ₹3000") return fare > 3000;
        });
    };


    const filteredBuses = busData.filter(bus => {
        return (
            checkPrice(bus) &&

            (!selectedFilters.timings.length ||
                selectedFilters.timings.includes(getTimeSlot(bus.timeD))) &&

            (!selectedFilters.busTypes.length ||
                selectedFilters.busTypes.includes(bus.type)) &&

            (!selectedFilters.travels.length ||
                selectedFilters.travels.includes(bus.name)) &&

            (!selectedFilters.boardingPoints.length ||
                bus.boarding?.some(b =>
                    selectedFilters.boardingPoints.includes(b.name)
                )) &&

            (!selectedFilters.droppingPoints.length ||
                bus.dropping?.some(d =>
                    selectedFilters.droppingPoints.includes(d.name)
                ))
        );
    });

    const [selectionError, setSelectionError] = useState("");

    const handleContinueClick = () => {
        if (selectedSeats.length === 0) {
            setSelectionError({
                message: "Please select at least one seat",
                type: "seat",
            });
            return;
        }

        if (!selectedBoarding) {
            setSelectionError({
                message: "Please select boarding point",
                type: "boarding",
            });
            return;
        }

        if (!selectedDropping) {
            setSelectionError({
                message: "Please select dropping point",
                type: "dropping",
            });
            return;
        }

        setSelectionError({ message: "", type: "" });
        handleBusBooking();
    };
    useEffect(() => {
        if (selectionError.message) {

        }
    }, [selectionError.message]);


    const getSeatImage = (seat, isSelected) => {
        const desc = seat.desc?.toLowerCase() || "";
        const isSleeper = desc.includes("sleeper");

        const statusMap = {
            0: "AFA",
            1: "AFM",
            2: "AFF",
            3: "BFA",
            4: "BFM",
            5: "BFF"
        };

        const status = statusMap[seat.status] || "AFA";
        const isZeroFare = !seat.fare || seat.fare.total === 0;

        //  Selected (priority)
        if (isSelected) {
            return isSleeper
                ? "/assets/images/sleeper_male_selected.png"
                : "/assets/images/seater_male_selected.png";
        }

        //  Block invalid seats
        if (isZeroFare) {
            return isSleeper
                ? "/assets/images/sleeper_male_blocked.png"
                : "/assets/images/seater_male_blocked.png";
        }

        //  SEATER
        if (!isSleeper) {
            switch (status) {
                case "AFF":
                    return "/assets/images/seater_female_available.png";

                case "AFM":
                    return "/assets/images/seater_male_available.png";

                case "BFF":
                    return "/assets/images/seater_female_block.png";

                case "BFA":
                case "BFM":
                    return "/assets/images/seater_male_blocked.png";

                case "AFA":
                default:
                    return "/assets/images/seater_male_available.png";
            }
        }

        //  SLEEPER
        if (isSleeper) {
            switch (status) {
                case "AFF":
                    return "/assets/images/sleeper_female_available.png";

                case "AFM":
                    return "/assets/images/sleeper_male_available.png";

                case "BFF":
                    return "/assets/images/sleeper_female_blocked.png";

                case "BFA":
                case "BFM":
                    return "/assets/images/sleeper_male_blocked.png";

                case "AFA":
                default:
                    return "/assets/images/sleeper_male_available.png";
            }
        }

        return "/assets/images/seater_male_available.png";
    };

    const renderSeats = (deckSeats, index) => {
        if (seatLoading[index]) {
            return (
                <p className="text-center">
                    <span className="loader"></span>
                </p>
            );
        }

        if (!deckSeats || deckSeats.length === 0) {
            return <p>No seats</p>;
        }

        return deckSeats.map((seat) => {
            const isSelected = selectedSeats.some(s => s.name === seat.name);

            const statusMap = {
                0: "AFA",
                1: "AFM",
                2: "AFF",
                3: "BFA",
                4: "BFM",
                5: "BFF"
            };

            const status = statusMap[seat.status];

            //  Correct booked logic
            const isBooked = ["BFA", "BFM", "BFF"].includes(status);

            const seatImg = getSeatImage(seat, isSelected);

            const desc = seat.desc?.toLowerCase() || "";
            const seatTypeClass = desc.includes("sleeper") ? "sleeper" : "seater";

            return (
                <div
                    key={seat.id || seat.name}
                    onClick={() => !isBooked && handleSeatClick(seat)}
                    className={`seat ${seatTypeClass} ${isBooked ? "booked" : ""} ${isSelected ? "selected" : ""}`}
                    style={{
                        gridColumn: `${seat.y + 1} / span ${seat.width || 1}`,
                        gridRow: `${seat.x + 1} / span ${seat.height || 1}`,
                    }}
                >
                    <div className="Seatsr">
                        <img src={seatImg} alt="seat" />
                    </div>

                    <div className="Seatsr_pri">
                        <i className="fa fa-inr"></i>
                        {seat.fare?.total
                            ? Number(seat.fare.companyAmount).toFixed(2)
                            : "—"}
                    </div>
                </div>
            );
        });
    };

    return (
        <>
            {loading && (
                <p className="text-center load">
                    <span className="loader"></span>
                </p>
            )}


            <Header />

            <section className="wrapers results">
                <div className="row">
                    <div className="col-md-12 hide-desktop">
                        <div
                            className="filter_menu"
                            onClick={() => setShowFilter(prev => !prev)}
                        >
                            <img src="/assets/images/filter.png" alt="filter" />
                        </div>
                         <div className="col-md-12 col-lg-12 only_moble">
                        {showFilter && (
                        <FilterLeft
                            filters={filters}
                            selectedFilters={selectedFilters}
                            onFilterChange={onFilterChange}
                        />
                        )}
                    </div>
                    </div>
                    {/* LEFT FILTER */}
                   
                    <div className="col-md-3 col-lg-3 mobile-none">                       
                        <FilterLeft
                            filters={filters}
                            selectedFilters={selectedFilters}
                            onFilterChange={onFilterChange}
                        />                      
                    </div>
                   

                    {/* RIGHT RESULT */}
                    <div className="col-md-9 col-lg-9">
                        <div className="sort_bus">
                            <div className="row">
                                <div className="col-md-10 col-lg-10">
                                    <div className="d-flex_bs">
                                        <span>{searchData?.fromCity || "From"}</span>
                                        <span>
                                            <i className="fa fa-arrow-right"></i>
                                        </span>
                                        <span>{searchData?.toCity || "To"}</span> ||
                                        <span className="red">
                                            {searchData?.journeyDate
                                                ? new Date(searchData.journeyDate).toDateString()
                                                : ""}
                                        </span>
                                        <span>|| Buses : </span>
                                        <span className="red">{busData.length}</span>
                                    </div>
                                </div>

                                <div className="col-md-2 col-lg-2 text-end">
                                    <button
                                        className="modify_btn_sr"
                                        data-bs-toggle="modal"
                                        data-bs-target="#ModifyBusResult"
                                    >
                                        Modify Result <i className="fa fa-arrow-right"></i>
                                    </button>
                                </div>
                            </div>
                        </div>



                        {/* BUS LIST */}
                        <div className="Results_Bus_list">
                            {busData.length > 0 ? (
                                filteredBuses.map((bus, index) => {
                                    const currentSeatData = seatData?.[index];

                                    const seats =
                                        currentSeatData?.data?.seats ||
                                        currentSeatData?.seats ||
                                        [];
                                    const lowerDeck = seats.filter((s) => s.z === 0);
                                    const upperDeck = seats.filter((s) => s.z === 1);
                                    const fare = bus.fares?.[0];

                                    return (
                                        <div className="result_repeat mb-2" key={index}>
                                            <div className="row">
                                                {/* LEFT */}

                                                <div class="col-md-9 col-lg-9">
                                                    <div class="row">
                                                        <div class="col-md-4 col-lg-4">
                                                            <p className='air_bs'>{bus.name}</p>
                                                            <h6 className='travel'>{bus.type}</h6>
                                                            <div className="bus_tags">
                                                                {bus.tags ? (
                                                                    Object.entries(bus.tags)
                                                                        .filter(([key, value]) => value === true)
                                                                        .map(([key], i) => (
                                                                            <p key={i} className="tag_item">
                                                                                {key}
                                                                            </p>
                                                                        ))
                                                                ) : (
                                                                    <p>No tags available</p>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div class="col-md-8 col-lg-8 border-left-right">
                                                            <div class="row">
                                                                <div class="col-md-4 col-lg-4 col-4">
                                                                    <div class="timer">
                                                                        <h4> {new Date(bus.timeD).toLocaleTimeString(
                                                                            [],
                                                                            {
                                                                                hour: "2-digit",
                                                                                minute: "2-digit",
                                                                            }
                                                                        )}</h4>
                                                                        <p className='sorce'>{searchData?.fromCity}</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-3 col-lg-3 col-3">
                                                                    <div class="deruation">
                                                                        <p>
                                                                            {Math.floor(bus.duration / 60)}h{" "}
                                                                            {bus.duration % 60}m
                                                                        </p>
                                                                        <div class="bordr_top">
                                                                            <i class="fa fa-bus"></i>
                                                                        </div>
                                                                        <p className="seat_lft">
                                                                            {bus.seats?.avlAll || 0} Seats Left
                                                                        </p>

                                                                    </div>
                                                                </div>

                                                                <div class="col-md-4 col-lg-4 offset-1 col-4">
                                                                    <div class="timer">
                                                                        <h4>
                                                                            {new Date(bus.timeA).toLocaleTimeString(
                                                                                [],
                                                                                {
                                                                                    hour: "2-digit",
                                                                                    minute: "2-digit",
                                                                                }
                                                                            )}
                                                                        </h4>
                                                                        <p className="sorce">
                                                                            {searchData?.toCity}
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>


                                                {/* RIGHT */}


                                                <div class="col-md-3 col-lg-3">
                                                    <div class="price_view">
                                                        <div class="row">

                                                            <div class="col-md-12 col-lg-12">
                                                                <div class="flight_charge bus_price">
                                                                    <p className='strt'>Starting From</p>
                                                                    <i class="fa fa-inr"></i>{fare?.companyAmount || "N/A"}
                                                                </div>
                                                                <p
                                                                    className={`policyStatus ${fare.policyStatus === "WithinPolicy"
                                                                        ? "text-success"
                                                                        : fare.policyStatus === "OutOfPolicy"
                                                                            ? "text-danger"
                                                                            : ""
                                                                        }`}
                                                                >
                                                                    <img
                                                                        src={
                                                                            fare.policyStatus === "WithinPolicy"
                                                                                ? "/assets/images/approved.png"
                                                                                : fare.policyStatus === "OutOfPolicy"
                                                                                    ? "/assets/images/cancelled.png"
                                                                                    : ""
                                                                        }
                                                                        alt="status"
                                                                    />

                                                                    {fare.policyStatus}
                                                                </p>


                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>



                                                <div className="col-md-12 col-lg-12">

                                                    {/* TAB HEADERS */}
                                                    <ul className="nav nav-pills bus-pills">

                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTabs[index] === "boarding" ? "active" : ""
                                                                    }`}
                                                                onClick={() => handleTabClick(index, "boarding")}
                                                            >
                                                                Boarding & Dropping Point
                                                            </button>
                                                        </li>

                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTabs[index] === "amenities" ? "active" : ""
                                                                    }`}
                                                                onClick={() => handleTabClick(index, "amenities")}
                                                            >
                                                                Amenities
                                                            </button>
                                                        </li>

                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTabs[index] === "policy" ? "active" : ""
                                                                    }`}
                                                                onClick={() => handleTabClick(index, "policy")}
                                                            >
                                                                Cancellation Policy
                                                            </button>
                                                        </li>
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link seatSelct ${activeTabs[index] === "selectseat" ? "active" : ""}`}
                                                                onClick={() => {
                                                                    handleTabClick(index, "selectseat");
                                                                    setSelectedBus(bus);
                                                                    setSelectedSeats([]);
                                                                    setSelectedBoarding(null);
                                                                    setSelectedDropping(null);
                                                                    BusSeatReviewAndBook(bus, index);
                                                                }}
                                                            >
                                                                Select Seat
                                                            </button>
                                                        </li>

                                                    </ul>

                                                    {/* TAB CONTENT */}

                                                    {/* BOARDING */}
                                                    {activeTabs[index] === "boarding" && (
                                                        <div className="info_cancel">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className='pointer'>

                                                                        <h6>Boarding Points</h6>
                                                                        <ul>
                                                                            {bus.boarding?.map((b, i) => (
                                                                                <li key={i}>
                                                                                    ({new Date(b.time).toLocaleTimeString([], {
                                                                                        hour: "2-digit",
                                                                                        minute: "2-digit",
                                                                                    })}){" "}
                                                                                    {b.name}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6">
                                                                    <div className='pointer'>
                                                                        <h6>Dropping Points</h6>
                                                                        <ul>
                                                                            {bus.dropping?.map((b, i) => (
                                                                                <li key={i}>
                                                                                    ({new Date(b.time).toLocaleTimeString([], {
                                                                                        hour: "2-digit",
                                                                                        minute: "2-digit",
                                                                                    })}){" "}
                                                                                    {b.name}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* AMENITIES */}
                                                    {activeTabs[index] === "amenities" && (
                                                        <div className="info_cancel">
                                                            <ul className="amenities">
                                                                {bus.amenities?.length > 0 ? (
                                                                    bus.amenities.map((item, i) => <li key={i}>{item}</li>)
                                                                ) : (
                                                                    <li>No amenities available</li>
                                                                )}
                                                            </ul>
                                                        </div>
                                                    )}

                                                    {/* POLICY */}
                                                    {activeTabs[index] === "policy" && (
                                                        <div className="info_cancel">
                                                            <table className="table table-bordered">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Cancellation Time</th>
                                                                        <th>Charges</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {bus.policy?.cancel?.map((item, i) => (
                                                                        <tr key={i}>
                                                                            <td>{item.span}</td>
                                                                            <td>{item.rate}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    )}

                                                    {activeTabs[index] === "selectseat" && (
                                                        <div className="info_cancel bordr">
                                                            <div className="row">
                                                                <div className="col-md-3">
                                                                    <h6 className='traveled'>{bus.name}</h6>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <div class="d-flex_bs">
                                                                        <span>{searchData?.fromCity || "From"}</span>
                                                                        <span>
                                                                            <i className="fa fa-arrow-right"></i>
                                                                        </span>
                                                                        <span>{searchData?.toCity || "To"}</span> ||
                                                                        <span className="red">
                                                                            {searchData?.journeyDate
                                                                                ? new Date(searchData.journeyDate).toDateString()
                                                                                : ""}
                                                                        </span>
                                                                    </div>
                                                                </div>



                                                                <div className="col-md-7 mt-5">
                                                                    <div className="row">

                                                                        {/* LOWER DECK */}
                                                                        <div className="col-md-6">
                                                                            <div className="box_seat">
                                                                                <div className="top_seat">
                                                                                    <h4>Lower deck</h4>
                                                                                    <img src="/assets/images/bus/car.png" alt="bus" />
                                                                                </div>

                                                                                <div className="seat-grid">
                                                                                    {seats.length === 0 ?
                                                                                        <p><span className="loader"></span></p> :
                                                                                        renderSeats(lowerDeck)}
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* UPPER DECK */}
                                                                        <div className="col-md-6">
                                                                            <div className="box_seat">
                                                                                <div className="top_seat">
                                                                                    <h4>Upper deck</h4>

                                                                                </div>

                                                                                <div className="seat-grid">
                                                                                    {renderSeats(upperDeck)}
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                    <div className="col-md-12 mt-8">
                                                                        <div class="seat-type-description">
                                                                            <ul class="space_between">
                                                                                <li>
                                                                                    <div class="Booked-seat">
                                                                                        <img src="/assets/images/seater_available.png" />
                                                                                        <img src="/assets/images/sleeper_available.png" />
                                                                                    </div>
                                                                                    <p>Available For Any</p></li>
                                                                                <li><div class="Booked-seat">
                                                                                    <img src="/assets/images/seater_selected.png" />
                                                                                    <img src="/assets/images/sleeper_selected.png" />
                                                                                </div>
                                                                                    <p>Selected </p></li>
                                                                                <li><div class="Booked-seat">
                                                                                    <img src="/assets/images/seater_female_block.png" />
                                                                                    <img src="/assets/images/sleeper_female_blocked.png" />
                                                                                </div>
                                                                                    <p>Book by Ladies</p></li><li>
                                                                                    <div class="Booked-seat">
                                                                                        <img src="/assets/images/seater_female.png" />
                                                                                        <img src="/assets/images/sleeper_female_available.png" />
                                                                                    </div>
                                                                                    <p>for Ladies</p></li>
                                                                                <li><div class="Booked-seat">
                                                                                    <img src="/assets/images/seater_booked.png" />
                                                                                    <img src="/assets/images/sleeper_blocked.png" />
                                                                                </div><p>Booked </p></li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-5 mt-5">
                                                                    <div className="box-shadow-bus">
                                                                        <div className="bus_tab-content">
                                                                            <h5 className="pointng">Boarding Point</h5>
                                                                            {bus?.boarding?.map((b, i) => (
                                                                                <>
                                                                                    <div
                                                                                        key={i}
                                                                                        onClick={() => {
                                                                                            setSelectedBoarding(b);

                                                                                            if (selectionError.type === "boarding") {
                                                                                                setSelectionError({ message: "", type: "" });
                                                                                            }
                                                                                        }}
                                                                                        className={`d-buse-bus ${selectedBoarding?.id === b.id ? "active-point" : ""}`}
                                                                                    >

                                                                                        <div className="point_dops">
                                                                                            <h4>{formatTime(b.time)}</h4>
                                                                                            <p>{formatDate(b.time)}</p>
                                                                                        </div>
                                                                                        <div className="dot_pont"> <span></span> </div>
                                                                                        <div className="point_dop">
                                                                                            <h4>{b.name}</h4>
                                                                                            <p>{b.name}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </>

                                                                            ))}
                                                                        </div>


                                                                        <div className="bus_tab-content">
                                                                            <h5 className="pointng">Dropping Point</h5>
                                                                            {bus?.dropping?.map((d, i) => (
                                                                                <>
                                                                                    <div
                                                                                        key={i}
                                                                                        onClick={() => {
                                                                                            setSelectedDropping(d);

                                                                                            if (selectionError.type === "dropping") {
                                                                                                setSelectionError({ message: "", type: "" });
                                                                                            }
                                                                                        }}
                                                                                        className={`d-buse-bus ${selectedDropping?.id === d.id ? "active-point" : ""}`}
                                                                                    >
                                                                                        <div className="point_dops">
                                                                                            <h4>{formatTime(d.time)}</h4>
                                                                                            <p>{formatDate(d.time)}</p>
                                                                                        </div>
                                                                                        <div className="dot_pont"> <span></span> </div>
                                                                                        <div className="point_dop">
                                                                                            <h4>{d.name}</h4>
                                                                                            <p>{d.name}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </>

                                                                            ))}
                                                                        </div>


                                                                    </div>
                                                                    <div className="col-md-12 dangr">
                                                                        {selectionError.message && (
                                                                            <div className="text-danger mt-2">
                                                                                {selectionError.message}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className="d-flexex">

                                                                        <div>
                                                                            <p
                                                                                className={`policyStatus ${fare.policyStatus === "WithinPolicy"
                                                                                    ? "text-success"
                                                                                    : fare.policyStatus === "OutOfPolicy"
                                                                                        ? "text-danger"
                                                                                        : ""
                                                                                    }`}
                                                                            >
                                                                                <img
                                                                                    src={
                                                                                        fare.policyStatus === "WithinPolicy"
                                                                                            ? "/assets/images/approved.png"
                                                                                            : fare.policyStatus === "OutOfPolicy"
                                                                                                ? "/assets/images/cancelled.png"
                                                                                                : ""
                                                                                    }
                                                                                    alt="status"
                                                                                />

                                                                                {fare.policyStatus}
                                                                            </p>

                                                                            {/* <h3>
                                                                                <i className="fa fa-inr"></i> {totalFare}
                                                                            </h3> */}
                                                                            <h3>
                                                                                <i className="fa fa-inr"></i> {Number(totalFare).toLocaleString("en-IN", {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                })}
                                                                            </h3>

                                                                            <p>
                                                                                <span>Selected Seat :</span>{" "}
                                                                                {selectedSeats.length > 0
                                                                                    ? selectedSeats.map((s) => s.name).join(", ")
                                                                                    : "None"}
                                                                            </p>
                                                                        </div>
                                                                        <div>
                                                                            <button
                                                                                className="btn btn-primary"
                                                                                onClick={handleContinueClick}
                                                                            >
                                                                                Continue
                                                                            </button>

                                                                        </div>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                !loading && (
                                    <p className="no-results">
                                        <img src="/assets/images/no-result.jpg" className="img-fluid" />
                                    </p>
                                )
                            )}
                        </div>

                    </div>
                </div>
            </section >




            {/* Seat Select Modal */}

            {/* Modify Result Modal */}
            <div className="modal fade" id="ModifyBusResult">
                <div className="modal-dialog custom-modal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Modify Result</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body-update">
                            <ModifySearch />
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Result;